
import { defineComponent } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useArenaList } from '@/modules/arena/item/model/list';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.ITEM.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, table } = useArenaList();
        return { table, query, total, list, fetchList, ROUTE_NAME_ARENA };
    }
});
